<template>
  <div class="call-records">
    <!-- 搜索区域 -->
    <div class="search-area">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="被叫号码">
          <el-input v-model="searchForm.called" placeholder="请输入被叫号码" clearable></el-input>
        </el-form-item>
        <el-form-item label="查询日期">
          <el-date-picker
            v-model="searchForm.beginTime"
            type="date"
            placeholder="选择查询日期"
            value-format="yyyyMMdd"
            :picker-options="{
              disabledDate(time) {
                return time.getTime() > Date.now()
              }
            }"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            class="search-btn"
            :style="{
              background: '#5579E7',
              borderColor: '#5579E7',
              borderRadius: '20px',
              padding: '10px 32px',
              fontSize: '14px'
            }"
            @click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table-area">
      <el-table 
        :data="records" 
        style="width: 100%"
        v-loading="loading"
        :height="300"
        :header-cell-style="{
          background: '#DAE3FF',
          color: '#2B4B75',
          fontWeight: '500',
          fontSize: '14px',
          height: '48px',
          padding: '0',
          borderBottom: '1px solid #E4E7ED'
        }"
        :cell-style="{
          color: '#2B4B75',
          fontSize: '14px',
          padding: '16px 0'
        }"
        :row-style="{
          height: '56px'
        }">
        <el-table-column prop="caller" label="坐席账号" min-width="120" align="center"></el-table-column>
        <el-table-column prop="called" label="被叫号码" min-width="120" align="center"></el-table-column>
        <!-- <el-table-column prop="calledCityCode" label="外显号码" min-width="120" align="center"></el-table-column> -->
        <el-table-column prop="beginTime" label="呼叫时间" min-width="160" align="center">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.beginTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="chargeCallTime" label="通话时长" min-width="100" align="center">
          <template slot-scope="scope">
            {{ formatDuration(scope.row.chargeCallTime) }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="hangupCause" label="挂机原因" min-width="120" align="center"></el-table-column> -->
        <el-table-column fixed="right" label="更多" width="80" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="showDetail(scope.row)">
              <span class="more-text">查看详情</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-area">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <call-detail
      :visible.sync="showDetailDialog"
      :detail="currentDetail"
    />
  </div>
</template>

<script>
import { formatDateTime, formatDuration } from '@/utils/format'
import CallDetail from './CallDetail.vue'

export default {
  name: 'CallRecords',
  components: {
    CallDetail
  },
  data() {
    return {
      searchForm: {
        called: '',
        beginTime: '',
        endTime: ''
      },
      loading: false,
      records: [],
      page: 1,
      pageSize: 10,
      total: 0,
      showDetailDialog: false,
      currentDetail: null
    }
  },
  created() {
    this.fetchRecords()
  },
  methods: {
    formatDateTime,
    formatDuration,
    
    // 查询记录
    async fetchRecords() {
      this.loading = true
      try {
        const response = await this.$http.post('/queryCdr', {
          pageNo: String(this.page),
          pageSize: String(this.pageSize),
          called: this.searchForm.called,
          searchDate: this.searchForm.beginTime
        })
        
        if (response.data.result) {
          this.records = response.data.data.data || []
          this.total = response.data.data.totalCount || 0
        } else {
          this.$message.error(response.data.message || '获取通话记录失败')
        }
      } catch (error) {
        console.error('获取通话记录失败:', error)
        this.$message.error('获取通话记录失败')
      } finally {
        this.loading = false
      }
    },

    // 搜索
    handleSearch() {
      this.page = 1
      this.fetchRecords()
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        called: '',
        beginTime: '',
        endTime: ''
      }
      this.handleSearch()
    },

    // 显示详情
    showDetail(row) {
      this.currentDetail = row
      this.showDetailDialog = true
    },

    // 分页相关
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchRecords()
    },

    handleCurrentChange(val) {
      this.page = val
      this.fetchRecords()
    }
  }
}
</script>

<style lang="less" scoped>
.call-records {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: white;
  border-radius: 8px;

  .search-area {
    margin-bottom: 20px;
    border-radius: 8px;

    .search-form {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      align-items: flex-end;

      .el-form-item {
        margin-bottom: 0;
      }

      :deep(.search-btn) {
        &:hover {
          background: #4264D9 !important;
          border-color: #4264D9 !important;
        }

        &:active {
          background: #3557CC !important;
          border-color: #3557CC !important;
        }
      }
    }
  }

  .table-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    
    .el-table {
      flex: 1;
    }
  }

  .pagination-area {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }

  .more-text {
    color: #5579E7;
    font-size: 14px;
  }
}

:deep(.el-table) {
  &::before {
    display: none;
  }

  .el-table__header-wrapper {
    border-radius: 0;
    overflow: hidden;
  }

  .el-table__body-wrapper {
    overflow-x: hidden;
    
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    
    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: #E4E7ED;
    }
    
    &::-webkit-scrollbar-track {
      border-radius: 3px;
      background: #F5F7FA;
    }
  }

  .el-table__fixed-right::before,
  .el-table__fixed::before {
    display: none;
  }

  .el-table__row {
    &:hover > td {
      background-color: #F1F5FF !important;
    }
  }
}
</style>
